import "./App.css";
import { Home, Navbar } from "./components";

function App() {
  return (
    <div className="app">
      <Navbar />
      <Home />
    </div>
  );
}

export default App;
